import React from 'react';
import MessagePreviewComponent from '../MessagePreviewComponent';
import { AuthContext } from '../../util/context';
import Panel from './ReadOnlyMessagePanel';

const ReadOnlyMessageSidePreview = ({ message, onClose, onOpenVideoWorkspace }) => {
    const context = React.useMemo(
        () => ({
            state: {
                selectedFolder: {
                    ...message?.folder,
                    accessCapabilities: {
                        canEdit: false,
                        canManage: false,
                        canGenerate: false,
                        canAdd: false,
                        canReadThreads: false
                    }
                },
                selectedMessage: message,
                showDeletedMessages: false,
                uploadProgress: {},
                uploadingMessages: {},
                selectedMessagesMap: {},
                messagesToSend: [],
                treeData: { items: {} },
                keys: {},
                holdingKeys: false
            },
            context: {
                setSelectedMessage: () => undefined,
                setUploadProgress: () => undefined,
                setClientError: () => undefined,
                setSelectedFolder: () => undefined,
                setHoldingKeys: () => undefined,
                setMessagesToSend: () => undefined,
                setSelectedMessagesMap: () => undefined,
                setShowMultiSelect: () => undefined
            }
        }),
        [message]
    );
    if (!message) return null;
    return (
        <AuthContext.Provider value={context}>
            <Panel>
                <MessagePreviewComponent
                    message={message}
                    onClose={onClose}
                    onClearSelection={onClose}
                    onOpenVideoWorkspace={onOpenVideoWorkspace}
                    readOnly
                    suppliedContentOnly
                    disableMoveMessage
                    hideUrlTranscriptAction
                />
            </Panel>
        </AuthContext.Provider>
    );
};

export default ReadOnlyMessageSidePreview;
